// extracted by mini-css-extract-plugin
export default {"dateOutput":"styles_date-output_vo9YO"};